import { useState } from 'react';
import {
  Box,
  Icon,
  UtilityText,
  GDSStyleObject,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';

const MASKED = '•••••••••••••••••••••';

interface MaskedValueProps {
  value: string;
  dir?: string;
  css?: GDSStyleObject;
}

export const MaskedValue = ({ value, dir, css: textCss }: MaskedValueProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const { formatMessage } = useIntl();

  const valueNode = isVisible ? (
    <UtilityText
      dir={dir}
      css={textCss}
      aria-label={`${formatMessage({
        id: 'STR_HEALTH_CARD_NUMBER',
      })}, ${value}`}
    >
      {value}
    </UtilityText>
  ) : (
    <UtilityText
      dir={dir}
      css={{ typography: '$subtitleTwo', fontWeight: 'bold' }}
      aria-label={formatMessage({ id: 'STR_HEALTH_CARD_NUMBER_HIDDEN' })}
    >
      <span aria-hidden="true">{MASKED}</span>
    </UtilityText>
  );

  const toggleButton = (
    <Box
      as="button"
      type="button"
      onClick={() => setIsVisible((v) => !v)}
      aria-label={formatMessage({
        id: isVisible
          ? 'STR_HIDE_HEALTH_CARD_NUMBER'
          : 'STR_SHOW_HEALTH_CARD_NUMBER',
      })}
      css={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '40px',
        height: '40px',
        borderRadius: '$small',
        '&:hover': {
          background: '$secondaryBackgroundHovered',
        },
        '&:active': {
          background: '$secondaryBackgroundPressed',
        },
      }}
    >
      <Icon
        icon={isVisible ? 'interfaceHidden' : 'interfaceVisible'}
        size="$oneAndHalf"
        tint="$onSurfaceIconPrimary"
      />
    </Box>
  );

  return (
    <Box css={{ display: 'inline-flex', alignItems: 'center', gap: '$half' }}>
      {valueNode}
      {toggleButton}
    </Box>
  );
};
